/**
 * /app/{slug}/support-tickets/{id} — one Contact WorkRight ticket for the
 * company: what was asked, the conversation with WorkRight, reply, mark
 * resolved / reopen. Not nested under the list layout (trailing
 * underscore). Bell notices for our replies link here.
 */
import { createFileRoute } from "@tanstack/react-router";
import { SupportTicketDetail } from "@/components/support/ticket-detail";

export const Route = createFileRoute("/_authgated/app/$tenantSlug/support-tickets_/$id")({
  component: SupportTicketRoute,
});

function SupportTicketRoute() {
  const { tenantSlug, id } = Route.useParams();
  return <SupportTicketDetail ticketId={Number(id) || 0} tenantSlug={tenantSlug} />;
}
